import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, message, Row } from 'antd';

import { Form, Field } from 'react-final-form';
import { CheckboxField, DateField, TextAreaField } from '../../atoms';
import { connect } from 'react-redux';
import { FORM_AGREEMENT_WITHDRAW } from '../../constants/formKeys';
import { FormActions } from '../../components';
import FormStateToRedux from '../FormStateToRedux';
import { tsAgreementWithdrawAction } from '../../actions/actionCreators/tsAgreementActionCreators';
import { formTsAgreementWithdrawFields } from '../../constants/forms/formTsAgreementWithdraw';
import { getAgreementWithdrawData } from '../../reducers/tsAgreementReducer';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './ValidateSchema';
import './TsAgreementWithdraw.scss';
import { fetchAccountGOSTsAssignmentCount } from '../../actions/actionCreators/accountGOSTsAssignmentsActionCreators';
import dayjs from '../../utils/dayjs';
import isEqual from 'lodash/isEqual';

export class TsAgreementWithdraw extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    selectedRowId: PropTypes.number.isRequired,
    hideWithdrawModal: PropTypes.func.isRequired,
    searchAgreements: PropTypes.func.isRequired,
    tsAgreementWithdrawAction: PropTypes.func.isRequired,
    fetchAssignmentCount: PropTypes.func.isRequired,
    resetSelection: PropTypes.func,
    initialValues: PropTypes.object,
  };

  onSubmit = async (values) => {
    const {
      selectedRowId,
      t,
      resetSelection,
      hideWithdrawModal,
      searchAgreements,
      fetchAssignmentCount,
    } = this.props;
    const res = await this.props.tsAgreementWithdrawAction({
      ...values,
      agreementId: selectedRowId,
    });
    if (!res?.error) {
      message.success(t('agreements.withdraw.performSuccess'));
      resetSelection?.();
      hideWithdrawModal();
      searchAgreements(0);
      fetchAssignmentCount();
    }
  };

  handleViolationChange = (event) => {
    const { checked } = event.target;
    this._form?.change(
      formTsAgreementWithdrawFields.EFFECTIVE_DATE,
      checked ? dayjs().format('DD.MM.YYYY') : null
    );
  };

  render() {
    const { t, selectedRowId, initialValues, hideWithdrawModal } = this.props;

    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit, form, values }) => {
          this._form = form;
          const effectiveDate =
            values[formTsAgreementWithdrawFields.EFFECTIVE_DATE];
          const reason = values[formTsAgreementWithdrawFields.REASON];
          const violation = values[formTsAgreementWithdrawFields.VIOLATION];
          const isSubmitDisabled = !(effectiveDate && reason);
          return (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_AGREEMENT_WITHDRAW} />
              <Row gutter={32}>
                <Col span={12}>
                  <div className="pb-2">
                    <span className="text-bold">
                      {t('agreements.withdraw.agreementNr')}:{' '}
                    </span>
                    <span>{selectedRowId}</span>
                  </div>
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12} className="effective-date">
                  <Field
                    className="date-field"
                    name={formTsAgreementWithdrawFields.EFFECTIVE_DATE}
                    label={t('agreements.withdraw.effectiveDate')}
                    tooltip={t('agreements.withdraw.effectiveDateTooltip')}
                    component={DateField}
                    props={{ disabled: violation }}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={64}>
                <Col span={32}>
                  <Field
                    name={formTsAgreementWithdrawFields.REASON}
                    label={t('agreements.withdraw.reason')}
                    component={TextAreaField}
                    rows={12}
                    maxLength={1500}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={24} className="violation">
                  <Field
                    name={formTsAgreementWithdrawFields.VIOLATION}
                    type="checkbox"
                    component={CheckboxField}
                    checkboxText={t('agreements.withdraw.violation')}
                    tooltip={t('agreements.withdraw.violationTooltip')}
                    hasFeedback={false}
                    onChange={this.handleViolationChange}
                  />
                </Col>
              </Row>
              <FormActions>
                <Button onClick={hideWithdrawModal}>
                  {t('agreements.withdraw.cancel')}{' '}
                </Button>
                <Button
                  disabled={isSubmitDisabled}
                  type="primary"
                  htmlType="submit"
                >
                  {t('agreements.withdraw.confirm')}
                </Button>
              </FormActions>
            </form>
          );
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { loading, data, error, ...formData } =
    getAgreementWithdrawData(state).toJS();
  return { initialValues: formData };
};

const mapDispatchToProps = {
  tsAgreementWithdrawAction,
  fetchAssignmentCount: fetchAccountGOSTsAssignmentCount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TsAgreementWithdraw);
